"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.reflect.construct.js");

require("core-js/modules/es6.object.assign.js");

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.match.js");

require("core-js/modules/es6.function.name.js");

require("core-js/modules/es6.object.set-prototype-of.js");

require("core-js/modules/es6.object.get-prototype-of.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactCropper = _interopRequireDefault(require("react-cropper"));

var _s3upload = _interopRequireDefault(require("react-s3-uploader/s3upload"));

var _utils = require("../../../../lib/utils");

require("../../../../sass/components/shared/elements/imageUpload/ImageCropper.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var rotateIcon = require('../../../../images/new-modal-image-rotate-icon.png');

var func = _propTypes.default.func,
    number = _propTypes.default.number,
    string = _propTypes.default.string;

var ImageCropper = /*#__PURE__*/function (_React$Component) {
  _inherits(ImageCropper, _React$Component);

  var _super = _createSuper(ImageCropper);

  function ImageCropper(props) {
    var _this;

    _classCallCheck(this, ImageCropper);

    _this = _super.call(this, props);
    _this.onUploadFinish = _this.onUploadFinish.bind(_assertThisInitialized(_this));
    _this.handleRotateImage = _this.handleRotateImage.bind(_assertThisInitialized(_this));
    _this.crop = _this.crop.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ImageCropper, [{
    key: "onUploadFinish",
    value: function onUploadFinish(res) {
      var handleUpload = this.props.handleUpload;
      var match = res.signedUrl.match(/(.*)\?/);
      var url = match && match[1];

      if (!url) {
        return console.error('Something has happened in onUploadFinish that should not have.');
      }

      (0, _utils.postToImgCompressLambda)(url).then(function (result) {
        if (result.data.res === 'Success') handleUpload(result.data.path);else handleUpload(url);
      }).catch(function (err) {
        console.error('Something has happened in onUploadFinish that should not have: ', err);
        handleUpload(url);
      });
    }
  }, {
    key: "handleRotateImage",
    value: function handleRotateImage() {
      this.cropper.rotate(-90);
    }
  }, {
    key: "crop",
    value: function crop() {
      var _this$props = this.props,
          imageName = _this$props.imageName,
          preCrop = _this$props.preCrop;
      preCrop();
      var croppedCanvas = this.cropper && this.cropper.getCroppedCanvas();
      var dataUrl = croppedCanvas.toDataURL('image/jpeg', 0.5);
      var blob = (0, _utils.dataURItoBlob)(dataUrl);
      var upload = new _s3upload.default({
        signingUrl: '/s3/dash/media/sign'
      });
      _s3upload.default.prototype.onFinishS3Put = this.onUploadFinish;
      blob.name = imageName || 'cropped-photo.jpg';
      upload.handleFileSelect([blob]);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          imageSrc = _this$props2.imageSrc,
          handleRemoveImage = _this$props2.handleRemoveImage,
          height = _this$props2.height,
          width = _this$props2.width,
          noAspect = _this$props2.noAspect,
          uploader = _this$props2.uploader;
      var optCropProps = {};
      if (!noAspect) optCropProps.aspectRatio = 1;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "cropper-section"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: uploader && 'cropper-header'
      }, !!uploader && /*#__PURE__*/_react.default.createElement("p", {
        className: "cropper-upload-text"
      }, "Uploader: ", /*#__PURE__*/_react.default.createElement("span", {
        className: "cropper-uploader-name"
      }, uploader)), /*#__PURE__*/_react.default.createElement("div", {
        className: "cropper-controls"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cropper-rotate",
        onClick: this.handleRotateImage
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: "cropper-rotate-icon",
        src: rotateIcon
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "cropper-rotate-text"
      }, "Rotate")), !!handleRemoveImage && /*#__PURE__*/_react.default.createElement("a", {
        className: "cropper-remove",
        onClick: handleRemoveImage
      }, "Remove Image"))), /*#__PURE__*/_react.default.createElement(_reactCropper.default, _extends({}, optCropProps, {
        src: imageSrc,
        viewMode: 1,
        style: {
          height: height,
          width: width
        },
        ref: function ref(el) {
          return _this2.cropper = el;
        }
      })));
    }
  }]);

  return ImageCropper;
}(_react.default.Component);

exports.default = ImageCropper;
ImageCropper.propTypes = {
  handleRemoveImage: func,
  handleUpload: func.isRequired,
  height: number,
  imageName: string.isRequired,
  imageSrc: string.isRequired,
  preCrop: func,
  width: string
};
ImageCropper.defaultProps = {
  handleRemoveImage: null,
  // default to null to hide Remove button
  height: 369,
  preCrop: function preCrop() {},
  width: '100%'
};